import React from 'react'
import styled from "styled-components"

import { typeBody02, typeBody03, typeHeading04, typeHeading05, typeLabel02 } from '../../theme/typography'

import { pixelate, unit, spacer, mediaQuery, SIZE } from '../../theme/metrics';
import { button } from '../../theme/core';


export const Container = styled.a`
	${button}
	background-color: ${props => props.primary ? props.theme.foreground : 'transparent'};
	border: 1px solid ${props => props.theme.foreground};
	color: ${props => props.primary ? props.theme.background : props.theme.foreground};
	display: block;
`
